<template>
    <div class="cell buttons" v-if="labels">
        <div class="buttons__group stacked-for-small buttons__group--left-large">
            <button @click="reset()" @keyup.enter="reset()" class="button secondary" tabindex="0">{{labels.newSearch}}</button>
            <button @click="openSaveDialog" @keyup.enter="openSaveDialog" class="button secondary" tabindex="0">{{labels.saveInMyLibrary}}</button>
        </div>

        <modal name="save-modal" :adaptive="true" :width="500" :height="'auto'" :pivot-y=".25" :click-to-close="true" class="modal modal--save">
            <FocusLock>
                <a @click="$modal.hide('save-modal')" @keyup.enter="$modal.hide('save-modal')" class="modal__close icon-cross" tabindex="0" aria-label="Luk modal boks"></a>
                <header class="modal__header">
                    <h2>{{texts.saveDialog.title}}</h2>
                </header>
                <div class="grid-x grid-padding-x">
                    <div class="modal__content cell" v-if="saveStatus === null">
                        <p>
                            {{texts.saveDialog.text}}
                        </p>
                        <div class="form__item" v-if="texts.saveDialog.name">
                            <input type="text" v-validate.initial="'required'" name="name" id="name" v-model="save.name" v-floatable v-focus>
                            <label for="name" class="floating-label">{{texts.saveDialog.name}}*</label>
                        </div>
                        <div class="form__item">
                            <textarea name="note" id="note" rows="4" v-model="save.msg" v-floatable></textarea>
                            <label for="note" class="floating-label">{{texts.saveDialog.note}}</label>
                        </div>                    
                    </div>

                    <div v-else-if="saveStatus === 'succes'" class="modal__content cell">
                        <p class="text-center">{{texts.saveDialog.succes}}</p>
                        <p>&nbsp;</p>
                    </div>
                    <div v-else-if="saveStatus === 'error'" class="modal__content cell">
                        <p class="text--red text-center">{{texts.saveDialog.error}}</p>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <footer class="form__divider form__links text-center" v-if="!saveStatus">
                    <button @click="saveToMyLib()" @keyup.enter="saveToMyLib()" class="button" :disabled="errors.items.length > 0 || !canSubmit" tabindex="0">{{texts.saveDialog.button}}</button>
                </footer>
            </FocusLock>
        </modal>

        <div class="buttons__group stacked-for-small buttons__group--right-large">
            <button :disabled="exportRunning" v-if="!hideExport" @click="saveAsExcell()" @keyup.enter="saveAsExcell()" class="button" tabindex="0"><span class="icon-file-excel"></span>{{labels.excel}}</button>
            <button @click="print()" @keyup.enter="print()" class="button" tabindex="0"><span class="icon-printer"></span>{{labels.print}}</button>
            <button @click="openEmailDialog" @keyup.enter="openEmailDialog" class="button" tabindex="0"><span class="icon-mail"></span>{{labels.email}}</button>
        </div>
      
        <modal name="email-modal" :adaptive="true" :width="500" :height="'auto'" :pivot-y=".25" :click-to-close="true" class="modal modal--email">
            <FocusLock>
                <a @click="$modal.hide('email-modal')" @keyup.enter="$modal.hide('email-modal')" class="modal__close icon-cross" tabindex="0" aria-label="Luk modal boks"></a>
                <header class="modal__header">
                    <h2>{{texts.emailDialog.title}}</h2>
                </header>
                <div class="grid-x grid-padding-x">
                    <div class="modal__content cell" v-if="emailSendStatus === null">
                        <p>
                            {{texts.emailDialog.text}}
                        </p>
                        <div class="form__item">
                            <input type="text" v-validate.initial="'required'" name="receiverName" id="receiverName" v-model="email.receiverName" v-floatable v-focus>
                            <label for="receiverName" class="floating-label">{{texts.emailDialog.receiverName}}*</label>
                        </div>  
                        <div class="form__item">
                            <input type="email" v-validate.initial="'required|email'" name="receiverEmail" id="receiverEmail" v-model="email.receiverEmail" v-floatable>
                            <label for="receiverEmail" class="floating-label">{{texts.emailDialog.receiverEmail}}*</label>
                        </div>  
                        <div class="form__item">
                            <input type="text" name="senderName" id="senderName" v-model="email.senderName" v-floatable>
                            <label for="senderName" class="floating-label">{{texts.emailDialog.senderName}}</label>
                        </div>  
                        <div class="form__item">
                            <input type="email" name="senderEmail" id="senderEmail" v-model="email.senderEmail" v-floatable>
                            <label for="senderEmail" class="floating-label">{{texts.emailDialog.senderEmail}}</label>
                        </div>
                        <div class="form__item">
                            <textarea name="msg" id="msg" rows="4" v-model="email.msg" v-floatable></textarea>
                            <label for="msg" class="floating-label">{{texts.emailDialog.message}}</label>
                        </div>                    
                    </div>
                    <div v-else-if="emailSendStatus === 'succes'" class="modal__content cell">
                        <p class="text-center">{{texts.emailDialog.success}}</p>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <footer class="form__divider form__links text-center" v-if="emailSendStatus === null">
                    <button @click="sendEmail()" @keyup.enter="sendEmail()" class="button" :disabled="errors.items.filter(x => x.vmId === errors.vmId).length > 0 || !canSubmit" tabindex="0">{{texts.emailDialog.button}}</button>
                </footer>
            </FocusLock>
        </modal>
            
    </div>  
</template>

<script>
import app_JobEffects from '../app_JobEffects.vue';
export default {
  components: { app_JobEffects },
    props: ['hideExport', 'saveStatus', 'texts'],
    data() {
        return {
            save: {
                msg: '',
                name: ''
            },
            email: {
                receiverName: '',
                receiverEmail: '',
                senderEmail: '',
                senderName: '',
                url: '',
                type: this.$parent.$options.name
            },
            modal: null,
            exportRunning: false,
            isLoggedIn: (window.vm.role !== 'public'),
            canSubmit: true,
            emailSendStatus: null,
        }
    },
    computed: {
        labels() {
            return this.$store.state.labels['buttons'];
        }
    },
    methods: {
        print() {
            window.print();
        },
        reset() {
            this.$store.commit("SEARCHFILTER", null);
            this.$store.commit("SEARCHFILTERDIRTY", true);
            this.$store.commit("SEARCH", null);

            if (window.vm.hasOwnProperty('jobEffectsApp')) {
                if (this.$route.name === "Search") {
                    this.$store.dispatch("getSearchFilter");
                } else {
                    this.$router.push({ name: "Search" });
                }
            } else {
                window.location.href = window.vm.paths.studySearch;
            }
        },
        saveAsExcell() {
            this.exportRunning = true;
            this.canSubmit = false;
            this.$store.dispatch('export', this.$route.query).then((e) => {
                setTimeout((e) => {
                    this.exportRunning = false;
                    this.canSubmit = true;
                }, 800);
            })
        },
        openSaveDialog() {
            this.modal = 'save';
            this.canSubmit = true;
            this.$modal.show('save-modal');
        },
        openEmailDialog() {
            this.canSubmit = true;
            this.modal = 'email';
            this.email = {
                receiverName: '',
                receiverEmail: '',
                senderEmail: '',
                senderName: '',
                url: '',
                type: this.$parent.$options.name
            };
            this.emailSendStatus = null;
            this.$modal.show('email-modal');
        },
        saveToMyLib() {
            this.canSubmit = false;
            this.$emit('save', { msg: this.save.msg, name: this.save.name });
        },
        sendEmail() {
            this.canSubmit = false;
            this.email.url = window.location.href;
            this.$store.dispatch("tip", this.email)
            .then(() => {
                this.emailSendStatus = "succes";
            })
            .catch(error => {
                this.emailSendStatus = "error";
                console.warn(error);
            });
        }
    },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'buttons' });
        this.$parent.$on("openSaveDialog", data => {
            this.openSaveDialog();
        });
    }
};
</script>





// WEBPACK FOOTER //
// src/components/Buttons.vue